import { Auth } from 'aws-amplify';

const API_URL = process.env.REACT_APP_API_URL || '';
const ACTIVE_CUSTOMER_STORAGE_KEY = 'active_customer_id';

export const getStoredActiveCustomerId = () => {
  try {
    return window.localStorage.getItem(ACTIVE_CUSTOMER_STORAGE_KEY) || '';
  } catch (error) {
    return '';
  }
};

export const setStoredActiveCustomerId = (customerId) => {
  try {
    if (customerId) {
      window.localStorage.setItem(ACTIVE_CUSTOMER_STORAGE_KEY, customerId);
    } else {
      window.localStorage.removeItem(ACTIVE_CUSTOMER_STORAGE_KEY);
    }
  } catch (error) {
    // Ignore localStorage failures and continue with claim-based fallback.
  }
};

class ApiClient {
  async getAuthHeaders() {
    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };
      const activeCustomerId = getStoredActiveCustomerId();
      if (activeCustomerId) {
        headers['X-Customer-Id'] = activeCustomerId;
      }
      return headers;
    } catch (error) {
      console.error('Error getting auth headers:', error);
      throw new Error('Not authenticated');
    }
  }

  async request(method, endpoint, data = null) {
    const headers = await this.getAuthHeaders();

    const config = {
      method,
      headers,
    };

    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
      config.body = JSON.stringify(data);
    }

    const response = await fetch(`${API_URL}${endpoint}`, config);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const error = new Error(errorData.error || `Request failed with status ${response.status}`);
      error.response = { data: errorData, status: response.status };
      throw error;
    }

    // Handle 204 No Content
    if (response.status === 204) {
      return { data: null };
    }

    const responseData = await response.json();
    return { data: responseData };
  }

  get(endpoint) {
    return this.request('GET', endpoint);
  }

  post(endpoint, data) {
    return this.request('POST', endpoint, data);
  }

  put(endpoint, data) {
    return this.request('PUT', endpoint, data);
  }

  patch(endpoint, data) {
    return this.request('PATCH', endpoint, data);
  }

  delete(endpoint) {
    return this.request('DELETE', endpoint);
  }
}

export const apiClient = new ApiClient();
export default apiClient;
